"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndicatorsListComponent = void 0;
const lodash_1 = __importDefault(require("lodash"));
const jquery_1 = __importDefault(require("jquery"));
const react_1 = __importDefault(require("react"));
const querystring_1 = __importDefault(require("querystring"));
const uiComponents = __importStar(require("../UIComponents"));
const expressions_1 = require("@mwater/expressions");
const ModalPopupComponent_1 = __importDefault(require("@mwater/react-library/lib/ModalPopupComponent"));
// Searchable list of indicators
class IndicatorsListComponent extends react_1.default.Component {
    addIndicatorConfirmPopup;
    constructor(props) {
        super(props);
        this.state = {
            indicators: null,
            search: ""
        };
    }
    componentDidMount() {
        // Get names and basic of forms
        const query = {};
        query.fields = JSON.stringify({ "design.name": 1, "design.desc": 1, "design.recommended": 1, deprecated: 1 });
        query.client = this.props.client;
        // Get list of all indicator names
        return jquery_1.default.getJSON(this.props.apiUrl + "indicators?" + querystring_1.default.stringify(query), (indicators) => {
            // Remove deprecated
            indicators = lodash_1.default.filter(indicators, (indicator) => !indicator.deprecated);
            // Sort by name
            indicators = lodash_1.default.sortByOrder(indicators, [
                (indicator) => ((this.props.extraTables || []).includes("indicator_values:" + indicator._id) ? 0 : 1),
                (indicator) => (indicator.design.recommended ? 0 : 1),
                (indicator) => expressions_1.ExprUtils.localizeString(indicator.design.name, T.locale)
            ], ["asc", "asc", "asc"]);
            return this.setState({
                indicators: lodash_1.default.map(indicators, (indicator) => ({
                    id: indicator._id,
                    name: expressions_1.ExprUtils.localizeString(indicator.design.name, T.locale),
                    desc: expressions_1.ExprUtils.localizeString(indicator.design.desc, T.locale)
                }))
            });
        }).fail((xhr) => {
            return this.setState({ error: xhr.responseText });
        });
    }
    handleTableRemove = (table) => {
        if (confirm(T `Remove ${expressions_1.ExprUtils.localizeString(table.name, T.locale)}? Any widgets that depend on it will no longer work properly.`)) {
            return this.props.onExtraTableRemove(table.id);
        }
    };
    searchRef = (comp) => {
        // Focus
        if (comp) {
            return comp.focus();
        }
    };
    handleSelect = (tableId) => {
        // Add table if not present
        if (!this.props.schema.getTable(tableId)) {
            this.props.onExtraTableAdd(tableId);
        }
        this.addIndicatorConfirmPopup.show(tableId);
    };
    render() {
        let indicators;
        if (this.state.error) {
            return react_1.default.createElement("div", { className: "alert alert-danger" }, this.state.error);
        }
        // Filter indicators
        if (this.state.search) {
            const escapeRegExp = (s) => s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
            const searchStringRegExp = new RegExp(escapeRegExp(this.state.search), "i");
            indicators = lodash_1.default.filter(this.state.indicators || [], (indicator) => indicator.name.match(searchStringRegExp));
        }
        else {
            ;
            ({ indicators } = this.state);
        }
        // Remove if already included
        indicators = lodash_1.default.filter(indicators || [], (f) => !(this.props.extraTables || []).includes(`indicator_values:${f.id}`));
        let tables = lodash_1.default.filter(this.props.schema.getTables(), (table) => table.id.match(/^indicator_values:/) && !table.deprecated);
        tables = lodash_1.default.sortBy(tables, (t) => t.name.en);
        return (react_1.default.createElement("div", null,
            react_1.default.createElement(AddIndicatorConfirmPopupComponent, { schema: this.props.schema, onChange: this.props.onChange, onExtraTableAdd: this.props.onExtraTableAdd, ref: (c) => {
                    this.addIndicatorConfirmPopup = c;
                } }),
            react_1.default.createElement("label", null, T `Included Indicators:`),
            tables.length > 0 ? (react_1.default.createElement(uiComponents.OptionListComponent, { items: lodash_1.default.map(tables, (table) => {
                    return {
                        name: expressions_1.ExprUtils.localizeString(table.name, T.locale),
                        desc: expressions_1.ExprUtils.localizeString(table.desc, T.locale),
                        onClick: this.handleSelect.bind(null, table.id),
                        onRemove: this.handleTableRemove.bind(null, table)
                    };
                }) })) : (react_1.default.createElement("div", null, T `None`)),
            react_1.default.createElement("br", null),
            react_1.default.createElement("label", null, T `All Indicators:`),
            !this.state.indicators || this.state.indicators.length === 0 ? (react_1.default.createElement("div", { className: "alert alert-info" },
                react_1.default.createElement("i", { className: "fa fa-spinner fa-spin" }),
                "\u00A0",
                T `Loading...`)) : (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("input", { type: "text", className: "form-control form-control-sm", placeholder: T `Search...`, key: "search", ref: this.searchRef, style: { maxWidth: "20em", marginBottom: 10 }, value: this.state.search, onChange: (ev) => this.setState({ search: ev.target.value }) }),
                react_1.default.createElement(uiComponents.OptionListComponent, { items: lodash_1.default.map(indicators, (indicator) => ({
                        name: indicator.name,
                        desc: indicator.desc,
                        onClick: this.handleSelect.bind(null, "indicator_values:" + indicator.id)
                    })) })))));
    }
}
exports.IndicatorsListComponent = IndicatorsListComponent;
class AddIndicatorConfirmPopupComponent extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            indicatorTable: null
        };
    }
    show(indicatorTable) {
        return this.setState({ visible: true, indicatorTable });
    }
    renderContents() {
        // Show loading if table not loaded
        if (!this.props.schema.getTable(this.state.indicatorTable)) {
            return (react_1.default.createElement("div", { className: "alert alert-info" },
                react_1.default.createElement("i", { className: "fa fa-spinner fa-spin" }),
                "\u00A0",
                T `Loading...`));
        }
        // Find entity links
        const entityColumns = lodash_1.default.filter(this.props.schema.getColumns(this.state.indicatorTable), (col) => col.join?.toTable?.match(/^entities\./));
        return (react_1.default.createElement("div", null,
            react_1.default.createElement("p", null, T `In general, it is better to get indicator values from the related site. Please select the site 
below, then find the indicator values in the 'Related Indicators' section. Or click on 'Use Raw Indicator' if you 
are certain that you want to use the raw indicator table`),
            react_1.default.createElement(uiComponents.OptionListComponent, { items: lodash_1.default.map(entityColumns, (entityColumn) => ({
                    name: expressions_1.ExprUtils.localizeString(entityColumn.name, T.locale),
                    desc: expressions_1.ExprUtils.localizeString(entityColumn.desc, T.locale),
                    onClick: () => {
                        // Select table
                        this.props.onChange(entityColumn.join.toTable);
                        return this.setState({ visible: false });
                    }
                })) }),
            react_1.default.createElement("br", null),
            react_1.default.createElement("div", null,
                react_1.default.createElement("a", { className: "link-plain", onClick: this.props.onChange.bind(null, this.state.indicatorTable) }, T `Use Raw Indicator`))));
    }
    render() {
        if (!this.state.visible) {
            return null;
        }
        return (react_1.default.createElement(ModalPopupComponent_1.default, { showCloseX: true, onClose: () => this.setState({ visible: false }), header: T `Add Indicator` }, this.renderContents()));
    }
}
